import { useMemo } from "react";

/** Shared labels for ReportView + ResolveReportModal from locale messages. */
const useReportViewLabels = (report, shared) =>
  useMemo(
    () => ({
      view: {
        reportId: report.viewReport.reportId,
        priority: report.viewReport.priority,
        metadata: report.viewReport.metadata,
        eventName: report.listReport.eventName,
        zone: report.listReport.zone,
        reportedDate: report.viewReport.reportedDate,
        reportedTime: report.viewReport.reportedTime,
        reportedAt: report.viewReport.reportedAt || report.reportedAt,
        resolvedAt: report.viewReport.resolvedAt || report.resolvedAt,
        durationOpen: report.viewReport.durationOpen,
        durationHoursUnit: report.viewReport.durationHoursUnit,
        durationMinutesUnit: report.viewReport.durationMinutesUnit,
        issueDescription: report.listReport.issueDesc,
        evidenceMedia: report.viewReport.evidenceMedia,
        filesAttached: report.viewReport.filesAttached,
        noPreview: report.noPreview,
        reportingBy: report.viewReport.reportingBy,
        comments: report.updates,
        noComments: report.viewReport.noComments,
        emptyCommentsTitle: report.viewReport.emptyCommentsTitle,
        emptyCommentsDescription: report.viewReport.emptyCommentsDescription,
        addCommentPlaceholder: report.viewReport.addCommentPlaceholder,
        commentMaxLengthError: report.viewReport.commentMaxLengthError,
        postComment: report.viewReport.postComment,
        resolveIssue: report.viewReport.resolveIssue,
        viewProfile: report.viewReport.viewProfile,
        open: report.listReport.open,
        closed: report.listReport.closed,
        supervisor: report.listReport.supervisor,
      },
      resolve: {
        title: report.resolveReport.title,
        description: report.resolveReport.description,
        commentLabel: report.resolveReport.commentLabel,
        commentPlaceholder: report.resolveReport.commentPlaceholder,
        cancel: shared.cancel,
        confirm: report.resolveReport.confirm,
      },
    }),
    [report, shared.cancel],
  );

export default useReportViewLabels;
